<template>
  <section class="calculator-form">
    <div class="form flow">
      <h2 class="section-title">
        Wat kunnen wij in een jaar voor jullie betekenen?
      </h2>

      <calculator-input
        :getter="transactieAantal"
        :setter="setTransactieAantal"
        :label="'Hoeveel transacties heeft jouw kantoor gemiddeld per jaar?'"
        :unit="'transacties'"
      />

      <calculator-input
        :getter="gemiddeldeCourtage"
        :setter="setGemiddeldeCourtage"
        :label="'Germiddelde courtage per object'"
        :unit="'%'"
        :slider="true"
      />

      <calculator-button
        :onClick="calculate"
        :color="'var(--clr-blue)'"
        :hollow="resultShown ? true : false"
        :disabled="transactieAantal && gemiddeldeCourtage ? false : true"
      >
        {{ resultShown ? "Opnieuw berekenen" : "Bereken" }}
      </calculator-button>
    </div>
    <div class="image">
      <img src="https://picsum.photos/600/400" alt="" />
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CalculatorButton from "./CalculatorButton.vue";
import CalculatorInput from "./CalculatorInput.vue";
export default {
  components: { CalculatorInput, CalculatorButton },
  computed: {
    ...mapState(["transactieAantal", "gemiddeldeCourtage", "resultShown"])
  },
  methods: {
    ...mapMutations(["setTransactieAantal", "setGemiddeldeCourtage"]),
    ...mapActions(["calculate"])
  }
};
</script>

<style lang="scss" scoped>
.calculator-form {
  padding: var(--spacing-lg) 0;
}

.section-title {
  font-size: var(--fs-24);
  font-weight: var(--fw-medium);
}

.image {
  display: none;
  img {
    width: 100%;
  }
}
</style>